import { useCallback } from 'react';

import {
  useLoyaltyLinkWalmartAccountMutation,
  useLoyaltyServiceLinkWalmartAccountMutation,
} from 'generated/graphql-gateway';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

interface LinkWalmartAccountInput {
  accessToken: string;
  refreshToken: string;
  loyaltyId: string;
}

export function useLinkWalmartAccount() {
  const enableServicePartners = Boolean(useFlag(LaunchDarklyFlag.ENABLE_LOYALTY_SERVICE_PARTNERS));

  const [legacyMutation, legacyResult] = useLoyaltyLinkWalmartAccountMutation();
  const [serviceMutation, serviceResult] = useLoyaltyServiceLinkWalmartAccountMutation();

  const linkWalmartAccount = useCallback(
    async ({ accessToken, refreshToken, loyaltyId }: LinkWalmartAccountInput) => {
      if (enableServicePartners) {
        const result = await serviceMutation({
          variables: { input: { accessToken, refreshToken } },
        });

        return {
          data: result.data?.loyaltyServiceLinkWalmartAccount,
          errors: result.errors,
        };
      }

      const result = await legacyMutation({
        variables: { input: { accessToken, refreshToken, loyaltyId } },
      });

      return {
        data: result.data?.loyaltyLinkWalmartAccount,
        errors: result.errors,
      };
    },
    [enableServicePartners, legacyMutation, serviceMutation]
  );

  const selectedResult = enableServicePartners ? serviceResult : legacyResult;
  const data = enableServicePartners
    ? serviceResult.data?.loyaltyServiceLinkWalmartAccount
    : legacyResult.data?.loyaltyLinkWalmartAccount;

  return {
    linkWalmartAccount,
    data,
    loading: selectedResult.loading,
    called: selectedResult.called,
  };
}
